import { useEffect, useState } from 'react';

export type Size = Pick<DOMRectReadOnly, 'height' | 'width'>;

const defaultState: Size = {
  width: 0,
  height: 0,
};

export const useSize = (element: HTMLElement | null) => {
  const [size, setSize] = useState<Size>(defaultState);

  useEffect(() => {
    if (!element || typeof window.ResizeObserver === 'undefined') {
      return;
    }

    const observer = new window.ResizeObserver((entries) => {
      if (entries[0]) {
        const { height, width } = entries[0].contentRect;
        setSize({ width, height });
      }
    });

    observer.observe(element);

    return () => {
      observer.disconnect();
    };
  }, [element]);

  return size;
};
